module.exports = __webpack_public_path__ + "static/media/hilda2.bc1dd732.jpg";